import "@arco-design/web-react/es/Layout/style";
import _Layout from "@arco-design/web-react/es/Layout";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import cs from 'classnames';
import styles from './style/index.module.less';

function Footer(props = {}) {
  const {
    className,
    ...restProps
  } = props;
  return /*#__PURE__*/React.createElement(_Layout.Footer, _extends({
    className: cs(styles.footer, className)
  }, restProps), /*#__PURE__*/React.createElement(_Button, {
    type: "text",
    style: {
      padding: '0 5px',
      display: 'flex',
      alignItems: 'center',
      color: 'black',
      height: 50
    },
    href: "https://discord.com/invite/pWxCgDdgwu",
    icon: /*#__PURE__*/React.createElement("svg", {
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      fill: "#000000"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M19.776 20.136c-1.368 0-2.448 1.2-2.448 2.664 0 1.464 1.104 2.664 2.448 2.664 1.368 0 2.448-1.2 2.448-2.664.024-1.464-1.08-2.664-2.448-2.664zm8.76 0c-1.368 0-2.448 1.2-2.448 2.664 0 1.464 1.104 2.664 2.448 2.664 1.368 0 2.448-1.2 2.448-2.664 0-1.464-1.08-2.664-2.448-2.664z",
      fill: "#000000"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M40.2 0H8.04C5.328 0 3.12 2.208 3.12 4.944v32.448c0 2.736 2.208 4.944 4.92 4.944h27.216l-1.272-4.44 3.072 2.856 2.904 2.688L45.12 48V4.944C45.12 2.208 42.912 0 40.2 0zm-9.264 31.344s-.864-1.032-1.584-1.944c3.144-.888 4.344-2.856 4.344-2.856a13.734 13.734 0 01-2.76 1.416c-1.2.504-2.352.84-3.48 1.032-2.304.432-4.416.312-6.216-.024a20.147 20.147 0 01-3.528-1.032 14.065 14.065 0 01-1.752-.816c-.072-.048-.144-.072-.216-.12a.331.331 0 01-.096-.072 8.42 8.42 0 01-.672-.408s1.152 1.92 4.2 2.832c-.72.912-1.608 1.992-1.608 1.992-5.304-.168-7.32-3.648-7.32-3.648 0-7.728 3.456-13.992 3.456-13.992 3.456-2.592 6.744-2.52 6.744-2.52l.24.288c-4.32 1.248-6.312 3.144-6.312 3.144s.528-.288 1.416-.696c2.568-1.128 4.608-1.44 5.448-1.512.144-.024.264-.048.408-.048 1.464-.192 3.12-.24 4.848-.048 2.28.264 4.728.936 7.224 2.304 0 0-1.896-1.8-5.976-3.048l.336-.384s3.288-.072 6.744 2.52c0 0 3.456 6.264 3.456 13.992 0 0-2.04 3.48-7.344 3.648z",
      fill: "#000000"
    }))
  }, /*#__PURE__*/React.createElement("div", null, "Discord")), /*#__PURE__*/React.createElement(_Button, {
    type: "text",
    style: {
      padding: '0 5px',
      display: 'flex',
      alignItems: 'center',
      color: 'black',
      height: 50
    },
    href: "https://t.me/+h57oCpnk4acyOGY1",
    icon: /*#__PURE__*/React.createElement("img", {
      height: "40",
      src: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Telegram_logo.svg/480px-Telegram_logo.svg.png",
      alt: ""
    })
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      paddingLeft: 5
    }
  }, "Telegram")), /*#__PURE__*/React.createElement("a", {
    href: "https://ko-fi.com/U6U2NE4IP",
    style: {
      height: 36
    },
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement("img", {
    height: "36",
    src: "https://storage.ko-fi.com/cdn/kofi1.png?v=3",
    alt: "Buy Me a Coffee at ko-fi.com"
  })), /*#__PURE__*/React.createElement(_Button, {
    // size="large"
    shape: "round",
    type: "primary",
    target: "_blank",
    style: {
      margin: '0 10px',
      height: 34
    },
    href: "https://card.histreams.net/"
  }, "\u6350\u8D60"));
}

export default Footer;